import classes from "./ReleaseActivityPage.module.css";
import React, {useState} from "react";
import {
    LMS_TYPE,
    POLL_TYPE,
} from "../../utils/constants";
import { useTranslation } from "react-i18next";
import YuJaButton from "../../components/standardization/YuJaButton";
import {useHistory, useParams} from "react-router-dom";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import Skeleton from "react-loading-skeleton";
import {useSession} from "../../hooks/useSession";
import {Button} from "@base-ui/react/button";


export default function ViewOneMoreStep({pollData}) {
    const { t } = useTranslation();
    const {poll} = pollData;
    const { pollKey, pollCode } = useParams();
    const history = useHistory();
    const {getIntegrationType} = useSynLMSConfiguration();
    const integrationType = getIntegrationType();
    const {parseSessionToken} = useSession();
    const [loading, setLoading] = useState(true);
    const {lmsCourseUrl=""} = parseSessionToken();


    const onClickConfiguration = () => {
        history.push({
            pathname: `/edit/${pollKey}/${pollCode}`,
            state: {
                view: "configuration",
                pollType: poll.pollType,
                isFromOneMoreStep: true,
            }
        });
    }

    const onViewAll = () => {
        history.push("/poll/user/");
    }

    const onClickLearnMore = () => {
        window.open(LMS_TYPE[integrationType].embeddingLearnMore, '_blank');
    }


    return (
        <div className={classes.parentContainer}>
            <div className={classes.mainCard} style={{alignItems: "center", padding: 25}}>
                <span style={{flex: 1}}/>
                <span className={classes.title} style={{fontSize: 20}}>
                    {t("questionBuilder.oneMoreStepActivity", {
                        activityType: poll.pollType === POLL_TYPE.ATTENDANCE
                            ? t("attendance.label")
                            : t("poll.mergedModeText"),
                        intType: LMS_TYPE[integrationType].name,
                    })}
                </span>
                <span className={classes.description}>
                    {t("questionBuilder.oneMoreStepDescriptionActivity", {
                        activityType: poll.pollType === POLL_TYPE.ATTENDANCE
                            ? t("attendance.label")
                            : t("poll.mergedModeText"),
                        intType: LMS_TYPE[integrationType].name,
                    })}
                    <Button className={classes.link} style={{marginLeft: 5}} onClick={onClickLearnMore}>
                        {t("common.learnMore") + "."}
                    </Button>
                </span>


                {!!loading &&
                    <div
                        style={{
                            display: "block",
                            width: "min(1000px, 100%)",
                            height: "auto",
                            aspectRatio: "16 / 9", /* modern browsers */
                            border: "none",
                            marginTop: 30,
                        }}
                    >
                        <Skeleton
                            inline={true}
                            borderRadius={4}
                            width={"100%"}
                            height={"100%"}
                        />
                    </div>
                }


                <iframe
                    title={t("poll.embeddingTutorial", {lms: LMS_TYPE[integrationType].name})}
                    allowFullScreen={true}
                    style={{
                        visibility: loading ? "hidden" : "visible",
                        borderRadius: 4,
                        display: "block",
                        width: "min(1000px, 100%)",
                        height: "auto",
                        aspectRatio: "16 / 9", /* modern browsers */
                        border: "none",
                        marginTop: 30,
                    }}
                    onLoad={() => setLoading(false)}
                    onError={(err) => {
                        console.log(err);
                        setLoading(false);
                    }}
                    src={LMS_TYPE[integrationType].embedVideo}
                />



                <div style={{display: "grid", marginTop: 30, gap: 10, gridTemplateColumns: "1fr 1fr 1fr"}}>
                    <YuJaButton
                        type={"secondary"}
                        style={{
                            width: "100%",
                            height: 35,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                        onClick={onClickConfiguration}
                    >
                        {t("questionBuilder.editConfigurationText")}
                    </YuJaButton>


                    <YuJaButton
                        type={"secondary"}
                        style={{
                            width: "100%",
                            height: 35,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                        onClick={onViewAll}
                    >
                        {t("questionBuilder.viewAllActivitiesText")}
                    </YuJaButton>

                    {!!lmsCourseUrl &&
                        <YuJaButton
                            style={{
                                width: "100%",
                                height: 35,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                            onClick={() => window.open(lmsCourseUrl)}
                        >
                            {t("poll.goToLmsCourse", {lms: LMS_TYPE[integrationType].shortName})}
                        </YuJaButton>
                    }
                </div>
                <span style={{flex: 2}}/>
            </div>
        </div>
    );
}